export default customElements.define('w-icon', class Icon extends wealthify.CustomElementBaseClass {

    static #defaultSize = '100';

    constructor () {
        const styleSelector = 'c-icon';
        const config = {
            styleSelector: styleSelector,
            templateHTML: '<w-icon-set data-root></w-icon-set>'
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    // Static

    static get eventSettings () {
        return {subscriptions: {[wealthify.ComponentEvents.globalEvents.DisabledToggled]: this.prototype.toggleDisabledFromCustomEvent}};
    }

    static get validUsages () {
        return ['basic', 'box-green', 'box-white', 'headline-green', 'headline-red', 'hero', 'product-gia', 'product-isa', 'product-jisa', 'product-iasa', 'product-cash-isa', 'product-sipp', 'product-disabled', 'theme-original', 'theme-ethical'];
    }

    static get validSizes () {
        return ['75', '100', '150', '200', '250', '400', '600', '900'];
    }

    static get usageSizeMap () {
        return {
            'box-white': '150',
            'box-green': '150',
            'hero': '600',
            'headline-green': '250',
            'headline-red': '250',
            'product-gia': '400',
            'product-isa': '400',
            'product-jisa': '400',
            'product-sipp': '400',
            'product-iasa': '400',
            'product-cash-isa': '400',
            'product-disabled': '400',
            'theme-original': '400',
            'theme-ethical': '400'
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('label', {default: ''}),
            new wealthify.Prop('size', {
                default: this.#defaultSize,
                type: wealthify.propTypes.ArrayItem(this.validSizes)
            }),
            new wealthify.Prop('type', {default: 'no-icon'}),
            new wealthify.Prop('usage', {
                default: 'basic',
                type: wealthify.propTypes.ArrayItem(this.validUsages),
            }),
            new wealthify.Prop('circled', {
                default: false,
                type: wealthify.propTypes.Boolean()
            })
        ];
    }

    get propCallbacks() {
        return {
            label: (value) => {
                if (value !== '') {
                    this.dom.root.setAttribute('aria-label', value);
                    this.dom.root.setAttribute('aria-hidden', false);
                } else {
                    this.dom.root.removeAttribute('aria-label');
                    this.dom.root.setAttribute('aria-hidden', true);
                }
            },
            size: () => {
                this.constructor.validSizes.forEach((size) => {
                    this.classList.remove(`${this.styleSelector}--size-${size}`);
                });

                this.classList.add(`${this.styleSelector}--size-${this.size}`);
            },
            type: (value) => {
                const type = value !== undefined ? this.type : 'no-icon';
                const classListAction = type === 'no-icon' ? 'add' : 'remove';

                this.dom.root.type = type;
                this.classList[classListAction]('u-display__none');
            },
            usage: () => {
                this.constructor.validUsages.forEach((usage) => {
                    this.classList.remove(`${this.styleSelector}--usage-${usage}`);
                });

                this.classList.add(`${this.styleSelector}--usage-${this.usage}`);

                // DOM will have the size attribute only if the developer has specified it themselves
                const isSizeOverridden = this.hasAttribute('size');

                if (!isSizeOverridden) {
                    this.size = this.constructor.usageSizeMap[this.usage] ?? this.size;
                }
            },
            circled: () => {
                const classListAction = this.circled ? 'add' : 'remove';

                this.classList[classListAction](`${this.styleSelector}--circled`);
            }
        };
    }

    // Public

    toggleDisabledFromCustomEvent (data) {
        this.classList[data.detail ? 'add' : 'remove'](`${this.styleSelector}--disabled`);
    }

});